import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithUserClaimMembership = { userClaimMembership: FilterState };

const userClaimMembershipSlice = createSlice({
    name: 'userClaimMembership',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default userClaimMembershipSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = userClaimMembershipSlice.actions;
export const selectFilters = (state: StateWithUserClaimMembership) => state.userClaimMembership.filters;
